/**
 * Exponential
 * -----------
 * 
 * June 2026
 */

import { InputNumber } from "primereact/inputnumber";

/**
 * Distribution component for editing the parameters of an exponential distribution.
 * 
 * @param {String} elementType      - Type of element tied to distribution. (actions, resources, entity_types)
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 * @param {Function} warningUpdater - Updates warnings for an element parameter.
 * @param {Object} configWarnings   - Verification warnings for model elements.
 */
function Exponential({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const exponentialWarnings = {
        'lambda': function(newLambda) { return newLambda <= 0 ? `${attr} - Lambda value must be positive` : null }
    }

    /**
     * Updates the exponential distribution's rate parameter for an attribute.
     * The rate parameter, lambda, depicts the number of events occurring in a time unit.
     * 
     * @param {float} newLambda - Updated value for the exponential distribution's lambda (rate parameter).
     */
    const handleExponential = (newLambda) => {
        warningUpdater(element.gid, attr, exponentialWarnings['lambda'](newLambda));

        const newExponential = {...element[attr].attr, lambda: newLambda};
        const newDist = {...element[attr], attr: newExponential};
        console.log("New exponential distribution: ", newExponential);
        distUpdater(attr, newDist);
    }

    return (
        <div>
            <label style={{ marginRight: '0.5rem' }}>Lambda (Rate Parameter):</label>
            <InputNumber value={element[attr].attr.lambda} onValueChange={(event) => handleExponential(event.target.value)} maxFractionDigits={2} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
        </div>
    )
}

export default Exponential;